
import { Link } from "react-router-dom";
import { Users, MessageSquareText, BookOpen, GraduationCap } from "lucide-react";
import { motion } from "framer-motion";

const Communities = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 20 }}
      className="container mx-auto py-8 px-4"
    >
      <h1 className="text-4xl font-bold mb-6">
        <span className="text-white">Flux</span>{" "}
        <span className="text-flux-cyan">Communities</span>
      </h1>
      
      <div className="grid gap-6">
        {/* Regular Navigation Cards */}
        <div className="grid gap-6">
          <Link 
            to="/communities/startups"
            className="p-6 rounded-xl bg-flux-black/50 border border-flux-cyan/20 backdrop-blur-xl
                     hover:border-flux-cyan/40 transition-all duration-300"
          >
            <h2 className="text-2xl font-bold text-flux-cyan mb-2 flex items-center">
              <Users className="w-5 h-5 mr-2" />
              Startups
            </h2>
            <p className="text-gray-400">Connect with founders and join exciting ventures.</p>
          </Link>

          <Link 
            to="/communities/forums"
            className="p-6 rounded-xl bg-flux-black/50 border border-flux-cyan/20 backdrop-blur-xl
                     hover:border-flux-cyan/40 transition-all duration-300"
          >
            <h2 className="text-2xl font-bold text-flux-cyan mb-2 flex items-center">
              <MessageSquareText className="w-5 h-5 mr-2" />
              Forums
            </h2>
            <p className="text-gray-400">Join discussions and connect with the community.</p>
          </Link>
          
          <Link 
            to="/communities/lessons"
            className="p-6 rounded-xl bg-flux-black/50 border border-flux-cyan/20 backdrop-blur-xl
                     hover:border-flux-cyan/40 transition-all duration-300"
          >
            <h2 className="text-2xl font-bold text-flux-cyan mb-2 flex items-center">
              <GraduationCap className="w-5 h-5 mr-2" />
              Lessons
            </h2>
            <p className="text-gray-400">Learn new skills with educational content and tutorials.</p>
          </Link>

          <Link 
            to="/blog"
            className="p-6 rounded-xl bg-flux-black/50 border border-flux-cyan/20 backdrop-blur-xl
                     hover:border-flux-cyan/40 transition-all duration-300"
          >
            <h2 className="text-2xl font-bold text-flux-cyan mb-2 flex items-center">
              <BookOpen className="w-5 h-5 mr-2" />
              Blog
            </h2>
            <p className="text-gray-400">Explore articles and stay updated with the latest news.</p>
          </Link>
        </div>
      </div>
    </motion.div>
  );
};

export default Communities;
